import { render } from "./index.vue?vue&type=template&id=2d1f6f15&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.css?vue&type=style&index=0&id=2d1f6f15&lang=css&scoped=true"
import "./index.vue?vue&type=style&index=1&id=2d1f6f15&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1f6f15"]])

export default __exports__